import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import Context from './index';
import { getAdminUserAPI, getStaffRolesAPI } from '../../Library/apis';
import { MENUITEMS } from '../../Layout/Sidebar/Menu';

const UserProvider = (props) => {

  const [userInfo, setUserInfo] = useState({
    userName: '',
    profileImageUrl: '',
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    phoneNumber: '',
    roles: [],
  });

  const [staffRoles, setStaffRoles] = useState([]);

  const [filteredMenuItems, setFilteredMenuItems] = useState(MENUITEMS(['']));

  useEffect(() => {
      if (userInfo.roles && userInfo.roles?.length && userInfo.roles?.includes("View Position") || userInfo.roles?.includes("Staff Position")) {
        updateStaffRoles();
      }
  }, [userInfo]);

  useEffect(() => {
    updateUserInfo();
  }, [userInfo]);

  const updateUserInfo = () => {
    getAdminUserAPI().then(res => {
      if (!_.isEqual(res.body, userInfo)) {
        setUserInfo(res.body);
        setFilteredMenuItems(MENUITEMS(res.body.roles));
      }
    }).catch(e => console.log(e));
  }

  const updateStaffRoles = () => {
    getStaffRolesAPI().then(res => {
      if (!_.isEqual(res.roles, staffRoles)) {
        setStaffRoles(res.roles);
      }
    }).catch(e => console.log(e));
  }

  return (
    <Context.Provider
      value={{
        ...props,
        userInfo,
        staffRoles,
        filteredMenuItems,
        setStaffRoles,
        setUserInfo,
        updateUserInfo,
        updateStaffRoles
      }}>
      {props.children}
    </Context.Provider>
  );
};

export default UserProvider;
